<template>
  <div :class="bemClass()" v-if="length > 0" v-bind="$attrs">
    <ul :class="bemClass('list')">
      <li :class="bemClass('item', 'previous')">
        <a :class="bemClass('link')" href="#" @click.prevent="previous">
          <slot name="previous-icon">
            <span :class="bemClass('icon')">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 477.175 477.175"><path d="M145.188 238.575l215.5-215.5c5.3-5.3 5.3-13.8 0-19.1s-13.8-5.3-19.1 0l-225.1 225.1c-5.3 5.3-5.3 13.8 0 19.1l225.1 225c2.6 2.6 6.1 4 9.5 4s6.9-1.3 9.5-4c5.3-5.3 5.3-13.8 0-19.1l-215.4-215.5z"/></svg>
            </span>
          </slot>
        </a>
      </li>

      <li
        :class="[
          bemClass('item'),
          {
            [bemClass('item', 'current').join(' ')]: item === modelValue
          }
        ]"
        v-for="(item, index) in items"
        :key="index"
      >
        <a :class="bemClass('link')" href="#" @click.prevent="go(item)">{{ item }}</a>
      </li>

      <li :class="bemClass('item', 'next')">
        <a :class="bemClass('link')" href="#" @click.prevent="next">
          <slot name="next-icon">
            <span :class="bemClass('icon')">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 477.175 477.175"><path d="M360.731 229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1 0s-5.3 13.8 0 19.1l215.5 215.5-215.5 215.5c-5.3 5.3-5.3 13.8 0 19.1 2.6 2.6 6.1 4 9.5 4 3.4 0 6.9-1.3 9.5-4l225.1-225.1c5.3-5.2 5.3-13.8.1-19z"/></svg>
            </span>
          </slot>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import useBem from '../../compositions/bem'
import { computed, toRefs } from 'vue'

export default {
  name: 'SelPagination',
  props: {
    modelValue: {
      type: [String, Number],
      default: ''
    },
    length: {
      type: Number,
      default: 0,
      validator: (val) => val % 1 === 0
    },
    totalVisible: [Number, String],
    modifier: {
      type: String,
      default: ''
    }
  },

  setup (props, { emit }) {
    const { modifier } = toRefs(props)
    const { bemClass } = useBem('sel-pagination', modifier)

    const go = (page) => {
      emit('update:modelValue', page)
    }

    const next = () => {
      emit('update:modelValue', props.modelValue + 1)
    }

    const previous = () => {
      emit('update:modelValue', props.modelValue - 1)
    }

    const range = (from, to) => {
      const range = []

      from = from > 0 ? from : 1

      for (let i = from; i <= to; i++) {
        range.push(i)
      }

      return range
    }

    const items = computed(() => {
      const totalVisible = parseInt(props.totalVisible, 10)

      if (totalVisible === 0) {
        return []
      }

      if (props.length <= totalVisible) {
        return range(1, props.length)
      }

      const even = totalVisible % 2 === 0 ? 1 : 0
      const left = Math.floor(totalVisible / 2)
      const right = props.length - left + 1 + even

      if (props.modelValue > left && props.modelValue < right) {
        const start = props.modelValue - left + 2
        const end = props.modelValue + left - 2 - even

        return [1, '...', ...range(start, end), '...', props.length]
      } else if (props.modelValue === left) {
        const end = props.modelValue + left - 1 - even
        return [...range(1, end), '...', props.length]
      } else if (props.modelValue === right) {
        const start = props.modelValue - left + 1
        return [1, '...', ...range(start, props.length)]
      } else {
        return [
          ...range(1, left),
          '...',
          ...range(right, props.length)
        ]
      }
    })

    return {
      bemClass,
      items,
      go,
      next,
      previous
    }
  }
}
</script>

<style scoped>
.sel-pagination {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.sel-pagination__icon {
  display: flex;
  width: 7px;
  height: 13px;
  align-items: center;
  justify-content: center;

  & svg {
    width: 13px;
    height: 13px;
  }
}

.sel-pagination__list {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 0;
  padding: 0;
  list-style: none;
}

.sel-pagination__item {
  position: relative;
  min-width: 16px;
  margin: 0 8px;
  text-align: center;
}

.sel-pagination__item--current {
  text-decoration: underline;
}

.sel-pagination__link {
  text-decoration: none;
}
</style>
